import { styled, Dialog, DialogActions, dialogClasses, Box } from '@mui/material';
import { vars } from '@tgtg/kit';

import { type ActionDialogProps } from './ActionDialog';

const mobileWidth = 343;
const smWidth = 450;
const lgWidth = 650;

export const StyledDialogActions = styled(DialogActions)(({ theme: { breakpoints } }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: vars.spacing.neutral.medium,
  alignSelf: 'stretch',
  width: '100%',
  padding: vars.spacing.neutral.large,
  flexWrap: 'wrap',

  '& >*': {
    alignSelf: 'stretch',
  },

  '>:not(:first-of-type)': {
    marginLeft: 0,
  },

  [breakpoints.up('sm')]: {
    gap: vars.spacing.neutral.large,
    flexDirection: 'row-reverse',
    justifyContent: 'flex-start',
  },
}));

export const StyledHeaderAndContent = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'stretch',
  gap: vars.spacing.neutral.xsmall,
  width: '100%',
  paddingTop: vars.spacing.neutral.large,
  paddingBottom: vars.spacing.neutral.small,
  paddingLeft: vars.spacing.neutral.large,
  paddingRight: vars.spacing.neutral.large,
  overflowY: 'auto',
}));

export const StyledDialog = styled(Dialog, {
  shouldForwardProp: (prop: string) => !['bannerHeight', 'isMobile', 'fullHeight'].includes(prop),
})<ActionDialogProps>(({ size, fullHeight, theme: { breakpoints, borderRadius, elevation } }) => ({
  [`& .${dialogClasses.paper}`]: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: mobileWidth,
    maxWidth: mobileWidth,
    borderRadius: borderRadius.medium,
    boxShadow: elevation[3],
    ...(fullHeight && {
      height: '70vh',
      [breakpoints.up('sm')]: {
        height: 'auto',
      },
    }),
    [breakpoints.up('sm')]: {
      width: lgWidth,
      maxWidth: lgWidth,
      ...(size === 'sm' && {
        width: smWidth,
        maxWidth: smWidth,
      }),
    },
  },
}));
